import React from 'react';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import { JoinedNamesCell } from '../components/workflow/CoverageDisplay';
import WorkflowStatusBadge from '../components/workflow/WorkflowStatusBadge';
import useWorkflowPerms from '../components/workflow/useWorkflowPerms';
import { formatDateShort } from '../utils/dateFormat';

// QC6 / QC7 acceptance — ONE list page (the submitter picks
// the type inside the form). Partner-reviewed: the list shows your own
// requests plus those covering engagements you lead.
const WorkflowQc = () => {
  const { canSubmit } = useWorkflowPerms('qc');
  return (
    <WorkflowListShell
      title="QC6 / QC7 Forms"
      subtitle="Client acceptance (QC6) and continuance (QC7)."
      newTo="/workflow/qc/new"
      canCreate={canSubmit}
      apiPath="/api/workflow/qc"
      rowTo={(r) => `/workflow/qc/${r.id}`}
      searchPlaceholder="Search request no, engagement, company or requester…"
      defaultSort={{ key: 'createdAt', direction: 'desc' }}
      columns={[
        { key: 'requestNo', label: 'Request', sortKey: 'requestNo', render: (r) => <span className="font-medium text-blue-700">{r.requestNo}</span> },
        {
          key: 'qcType', label: 'Type',
          render: (r) => (
            <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-blue-50 text-blue-700">{r.qcType}</span>
          ),
        },
        // 每案自帶公司／UEN／FYE；不另立 FYE 欄——一張單可涵蓋多案、各案 FYE 日期可不同，單一欄只印得出第一案。
        { key: 'engagements', label: 'Engagement(s)', render: (r) => <JoinedNamesCell value={r.engagementNames} fallback={r.entityName} now={r.engagementNamesNow || r.entityNameNow} serviceDescription={r.firstServiceDescription} /> },
        { key: 'status', label: 'Status', sortKey: 'status', render: (r) => <WorkflowStatusBadge status={r.status} /> },
        { key: 'requester', label: 'Requested By', render: (r) => <span className="text-slate-500">{r.requesterEmail}</span> },
        { key: 'createdAt', label: 'Submitted', sortKey: 'createdAt', className: 'text-slate-600 whitespace-nowrap', render: (r) => formatDateShort(r.createdAt) },
      ]}
    />
  );
};

export default WorkflowQc;
